import script from "./WizardStepIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardStepIndicator.vue?vue&type=script&setup=true&lang=js"

import "./WizardStepIndicator.vue?vue&type=style&index=0&id=6c0ac1b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c0ac1b8"]])

export default __exports__